import { gql } from 'urql';

import { CATEGORY_FRAGMENT } from 'gql/fragments/category';

export const CATEGORY_BY_ID_QUERY = gql`
  query CategoryById($id: String!) {
    categoryById(id: $id) {
      ...category
      parentCategory {
        ...category
        parentCategory {
          ...category
          parentCategory {
            ...category
            parentCategory {
              ...category
            }
          }
        }
      }
    }
  }

  ${CATEGORY_FRAGMENT}
`;

export const CATEGORY_SIZE_CHART_QUERY = gql`
  query CategorySizeChart($id: String!) {
    categoryById(id: $id) {
      id
      sizeCharts {
        id
        name
        body
      }
    }
  }
`;
